import React from 'react';
import { Check, Star, Shield, Zap } from 'lucide-react';
export function PricingTable() {
  return <section id="pricing" className="py-8 px-4 bg-[#0a0c0e] border-t border-card-border relative" data-id="element-228">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-cyan-neon/5 rounded-full blur-[150px] pointer-events-none" data-id="element-229"></div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-230">
        <div className="text-center mb-16" data-id="element-231">
          <h2 className="font-bebas text-4xl md:text-6xl text-white mb-4" data-id="element-232">
            LA ESCALERA DE <span className="text-cyan-neon" data-id="element-233">SOBERANÍA</span>
          </h2>
          <p className="font-inter text-lg max-w-2xl mx-auto font-[700] text-[#FAFBFE]" data-id="element-234">
            Elige tu nivel de blindaje
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-end max-w-6xl mx-auto" data-id="element-235">
          {/* Tier 1: Esencial */}
          <div className="bg-card-dark border border-card-border rounded-2xl p-8 flex flex-col h-full relative" data-id="element-236">
            <div className="mb-8" data-id="element-237">
              <h3 className="font-bebas tracking-wide mb-2 text-[32px] text-[#00F2FF]" data-id="element-238">
                BLINDAJE ESENCIAL
              </h3>
              <div className="flex items-baseline gap-2" data-id="element-239">
                <span className="font-bebas text-white text-[64px]" data-id="element-240">$6.39</span>
                <span className="text-text-muted font-inter text-sm" data-id="element-241">USD</span>
              </div>
              <p className="text-sm text-text-muted mt-4 font-inter" data-id="element-242">
                (Precio normal: $47 USD) <br data-id="element-243" />⏰ Oferta por tiempo limitado
              </p>
              <p className="text-sm text-text-muted mt-4 font-inter" data-id="element-244">
                El sistema táctico completo para desmantelar el hábito en las
                próximas 24-72 horas.
              </p>
            </div>
            <ul className="space-y-4 mb-8 flex-1 font-inter text-sm text-text-muted" data-id="element-245">
              <li className="flex items-start gap-3" data-id="element-246">
                <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-247" />
                <span data-id="element-248">Primera victoria en menos de 24 horas</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-249">
                <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-250" />
                <span data-id="element-251">Reducción del 80% en impulsos en 7 días</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-252">
                <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-253" />
                <span data-id="element-254">Coherencia total en 30 días</span>
              </li>
            </ul>

            <div className="mb-8" data-id="element-255">
              <img src="https://cdn.magicpatterns.com/uploads/dyiAZ8efPd1VmJdWYsFdKZ/MOCKUP_PRINCIPAL_CON_SUS_BONUS.png" alt="Protocolo de Blindaje con sus 3 Bonus" className="w-full h-auto rounded-lg" data-id="element-256" />
            </div>
            <ul className="space-y-4 mb-8 flex-1 font-inter text-sm text-text-muted" data-id="element-257">
              <li className="flex items-start gap-3" data-id="element-258">
                <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-259" />
                <span data-id="element-260">Acceso Inmediato por Emails</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-261">
                <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-262" />
                <span data-id="element-263">Ebook Protocolo de Blindaje Completo (PDF)</span>
              </li>
            </ul>

            <div className="mb-4" data-id="element-264">
              <span className="font-bebas text-lg text-cyan-neon tracking-wider" data-id="element-265">
                🎁 3 BONUS EXCLUSIVOS
              </span>
            </div>

            <ul className="space-y-4 mb-8 flex-1 font-inter text-sm text-text-muted" data-id="element-266">
              <li className="flex items-start gap-3" data-id="element-267">
                <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-268" />
                <span data-id="element-269">
                  <strong className="text-white" data-id="element-270">Bonus #1:</strong> Auxilio 60s
                  (Audio de Emergencia)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-271">
                <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-272" />
                <span data-id="element-273">
                  <strong className="text-white" data-id="element-274">Bonus #2:</strong> Mapa de
                  Disparadores
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-275">
                <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-276" />
                <span data-id="element-277">
                  <strong className="text-white" data-id="element-278">Bonus #3:</strong> Restauración
                  V10
                </span>
              </li>
            </ul>

            <button className="w-full py-4 border border-cyan-neon text-cyan-neon font-bebas text-xl tracking-wider rounded-lg hover:bg-cyan-neon hover:text-deep-black transition-colors duration-300" data-id="element-279">
              ACTIVAR ESENCIAL
            </button>
          </div>

          {/* Tier 2: PRO (Highlighted) */}
          <div className="bg-card-dark border-2 border-cyan-neon rounded-2xl p-8 flex flex-col h-full relative glow-cyan-intense transform lg:-translate-y-4 z-10" data-id="element-280">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-cyan-neon text-deep-black font-bebas px-4 py-1 rounded-full text-sm tracking-wider flex items-center gap-1" data-id="element-281">
              <Star className="w-4 h-4 fill-deep-black" data-id="element-282" /> RECOMENDADO
            </div>

            <div className="mb-8 mt-2" data-id="element-283">
              <h3 className="font-bebas text-cyan-neon tracking-wide mb-2 text-[32px]" data-id="element-284">
                BLINDAJE PRO - AUDIBLE
              </h3>
              <div className="flex items-baseline gap-2" data-id="element-285">
                <span className="font-bebas text-6xl text-white" data-id="element-286">$14.99</span>
                <span className="text-text-muted font-inter text-sm" data-id="element-287">USD</span>
              </div>
              <p className="text-sm text-gray-300 mt-4 font-inter" data-id="element-288">
                Todo el sistema esencial + la Versión Audio para reprogramar tu
                mente mientras entrenas o conduces con privacidad total.
              </p>
            </div>

            <div className="mb-8" data-id="element-289">
              <img src="https://cdn.magicpatterns.com/uploads/nBs5CfGyEfCHEQnaTgNp6z/TODOS_MAS_EL_AUDIOLIBRO.png" alt="Protocolo de Blindaje con Audiolibro y Bonus" className="w-full h-auto rounded-lg" data-id="element-290" />
            </div>

            <ul className="space-y-4 mb-8 flex-1 font-inter text-sm text-gray-300" data-id="element-291">
              <li className="flex items-start gap-3" data-id="element-292">
                <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-293" />
                <span data-id="element-294">
                  <strong className="text-white" data-id="element-295">
                    Todo lo del plan Esencial
                  </strong>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-296">
                <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-297" />
                <span data-id="element-298">Audiolibro Completo (Privacidad Total)</span>
              </li>
            </ul>

            <button className="btn-3d-glow w-full py-5 text-xl" data-id="element-299">
              SÍ, QUIERO EL AUDIO
            </button>
          </div>

          {/* Tier 3: Soberanía Total */}
          <div className="bg-card-dark border border-card-border rounded-2xl p-8 flex flex-col h-full relative" data-id="element-300">
            <div className="mb-8" data-id="element-301">
              <h3 className="font-bebas tracking-wide mb-2 text-[#00F2FF] text-[32px]" data-id="element-302">
                SOBERANÍA TOTAL
              </h3>
              <div className="flex items-baseline gap-2" data-id="element-303">
                <span className="font-bebas text-5xl text-white" data-id="element-304">$19.99</span>
                <span className="text-text-muted font-inter text-sm" data-id="element-305">USD</span>
              </div>
              <p className="text-sm text-text-muted mt-4 font-inter" data-id="element-306">
                El arsenal definitivo. Hackea tu subconsciente mientras duermes.
              </p>
            </div>

            <div className="mb-8" data-id="element-307">
              <img src="https://cdn.magicpatterns.com/uploads/xymyWXftnSbKSg84VB31vB/TODOS_MAS_LA_REPORGRAMACION.png" alt="Bundle Completo 5 Piezas - Soberanía Total" className="w-full h-auto rounded-lg" data-id="element-308" />
            </div>

            <ul className="space-y-4 mb-8 flex-1 font-inter text-sm text-text-muted" data-id="element-309">
              <li className="flex items-start gap-3" data-id="element-310">
                <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-311" />
                <span data-id="element-312">
                  <strong className="text-white" data-id="element-313">Todo lo del plan PRO</strong>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-314">
                <Zap className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-315" />
                <span className="text-white" data-id="element-316">
                  Audio Reprogramación Medianoche (Theta 6Hz)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-317">
                <Check className="w-5 h-5 text-cyan-neon shrink-0" data-id="element-318" />
                <span data-id="element-319">Acelera recuperación al 300%</span>
              </li>
            </ul>

            <button className="w-full py-4 border border-cyan-neon text-cyan-neon font-bebas text-xl tracking-wider rounded-lg hover:bg-cyan-neon hover:text-deep-black transition-colors duration-300" data-id="element-320">
              QUIERO SOBERANÍA TOTAL
            </button>
          </div>
        </div>
      </div>
    </section>;
}